import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable()
export class Interceptor implements HttpInterceptor {
    private static isHandlingUnauthorized = false;
    private static lastUnauthorizedHandledAt = 0;
    private static isSessionModalOpen = false;

    constructor(private router: Router, private modal: NzModalService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                const errMsg = (error?.error as any)?.message || '';
                if (error?.status === 403 && typeof errMsg === 'string' && errMsg.toLowerCase().includes('onboarding')) {
                    this.router.navigate(['/onboarding']);
                    return throwError(error);
                }
                // if(error?.status == 401 && !this.isSessionExpiredAlertShown && request.url.includes('/available-leads')) {
                if (error?.status === 401) {
                    const isOnSigninPage = this.router.url.includes('/signin');
                    const now = Date.now();
                    const recentlyHandled = now - Interceptor.lastUnauthorizedHandledAt < 2500;

                    if (!isOnSigninPage && !Interceptor.isHandlingUnauthorized && !recentlyHandled) {
                        Interceptor.isHandlingUnauthorized = true;
                        Interceptor.lastUnauthorizedHandledAt = now;
                        this.showSessionExpiredModal();
                    }
                }
                return throwError(error);
            })
        )
    }

    private showSessionExpiredModal(): void {
        if (Interceptor.isSessionModalOpen) {
            return;
        }

        Interceptor.isSessionModalOpen = true;
        const modalRef = this.modal.warning({
            nzTitle: 'Session expired',
            nzContent: 'Your session has ended. Please sign in again to continue.',
            nzOkText: 'Go to sign in',
            nzClosable: false,
            nzMaskClosable: false,
            nzOnOk: () => {
                this.clearSessionStorageWithHiddenChats();
                this.router.navigate(['/signin']).finally(() => {
                    setTimeout(() => {
                        Interceptor.isHandlingUnauthorized = false;
                    }, 400);
                });
            },
        });
        modalRef.afterClose.subscribe(() => {
            Interceptor.isSessionModalOpen = false;
            Interceptor.isHandlingUnauthorized = false;
        });
    }

    private clearSessionStorageWithHiddenChats(): void {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const userId = user?.crm_id ? String(user.crm_id) : '';
        const hiddenConversationKey = userId
            ? `chat_hidden_conversations_${userId}`
            : '';
        const hiddenConversationValue = hiddenConversationKey
            ? localStorage.getItem(hiddenConversationKey)
            : null;

        localStorage.removeItem('accessToken');
        localStorage.clear();

        if (hiddenConversationKey && hiddenConversationValue !== null) {
            localStorage.setItem(hiddenConversationKey, hiddenConversationValue);
        }
    }
};
